module.exports = __webpack_public_path__ + "img/oneBlue.0602b0e3.jpg";